import store from '@/store/index.js';
import checkPageVersion from '@/utils/check-page-version';

export default async (to, from, next) => {
	let pageLoaderActive = true;

	if (to.meta && to.meta.noPageLoader) {
		pageLoaderActive = false;
	}

	if (pageLoaderActive) {
		store.dispatch('app/setPageLoadingAction', true);
	}

	// if (to && to.params && to.params.companyid) {
	// 	await store.dispatch(
	// 		'user/currentCompanyIdAction',
	// 		parseInt(to.params.companyid)
	// 	);
	// }

	if (to.meta && to.meta.clearState) {
		//clears menu etc stored in local storage
		//do this on the default page, ie Dashboard
		store.dispatch('user/clearStateAction');
	}

	if (to.meta && !to.meta.isPublic) {
		let display;

		if (to.meta && to.meta.displayConcurrentUsers) {
			display = true;
		}

		store.dispatch('communicationHub/setDisplayConcurrentUsersAction', {
			displayConcurrentUsers: display,
			groupName: to.path
		});
	}

	if (to.meta && to.meta.isPublic) {
		//if a public page, disable autologoff
		store.dispatch('user/setAutoLogoffStatusAction', false);
		next();
	} else {
		store.dispatch('principal/checkAccess', to).then(hasAccess => {
			checkPageVersion(to, store.getters['principal/user']);
			if (hasAccess) {
				next();
			}
		});
	}
};
